import { ILang } from '@libs/interfaces';

// Define an array of supported languages
export const LANGS: ILang[] = [
  {
    code: 'es',
    desc: 'Español',
  },
  {
    code: 'pt',
    desc: 'Português',
    default: true, // Portuguese is set as the default language
  },
  {
    code: 'en',
    desc: 'English',
  },
];

/**
 * Sets the language preference.
 * @param lang - The language preference.
 * @returns The validated language preference.
 */
export const SetLangOrDefault = (lang: string): string => {
  // Find the language code in the LANGS array
  // If not found, default to 'pt' (Portuguese)
  return LANGS.find(l => l.code === lang)?.code || LANGS.find(l => l.default)?.code;
};
